import React from 'react'

const DashboardMainContainer = ({children,className}) => {
  return (
    <>
    <div className ={`lg:bg-mistygray lg:rounded-xl ${className}`}>
    {children}
    </div>
    </>
  )
}

export default DashboardMainContainer